<p-progress-spinner class="spinner w-8.75 h-8.75"></p-progress-spinner>

<h4 [innerHTML]="loadingLabel()" class="text-(length:--font-size-headline-m) font-medium mb-0 ml-4"></h4>
